/*-----------------------------
Media Query Checks
-----------------------------*/

export let isDesktop = true

if (typeof window !== `undefined`) {
  isDesktop = window.matchMedia("(min-width: 769px)").matches
}
